const formatter = (value, searched) => {
  if (value && searched)
    return value
      .split(' ')
      ?.find((name) => name?.toLowerCase().startsWith(searched.toLowerCase()));
};

const searchParser = (data, search, code_only) => {
  if (code_only) {
    const codes = search?.split(',');
    if (codes?.length > 1)
      return data
        .filter((el) => el.is_city)
        .filter((el) => el.airports.find((air) => codes.includes(air.code)));
    else
      return data.filter(
        (el) =>
          formatter(el.city_code, search) || formatter(el.airport_code, search)
      );
  } else {
    return data.filter(
      (el) =>
        formatter(el.city_name, search) ||
        formatter(el.city_code, search) ||
        formatter(el.airport_name, search) ||
        formatter(el.airport_code, search)
    );
  }
};

export default searchParser;
